import { supabase } from '../lib/supabase'

type Annidato<T> = T | T[] | null
const uno = <T,>(v: Annidato<T>): T | null => (Array.isArray(v) ? (v[0] ?? null) : v)

export interface Attivita {
  readonly id: number
  readonly quando: string
  readonly utente: string
  readonly attivita: string
  readonly dettagli: string
}

export async function elencaAttivita(): Promise<Attivita[]> {
  const { data, error } = await supabase
    .from('log_attivita')
    .select('id, attivita, dettagli, creato_il, account(email)')
    .order('creato_il', { ascending: false })
    .limit(200)
  if (error) throw new Error(error.message)
  return ((data ?? []) as unknown as { id: number; attivita: string; dettagli: string; creato_il: string; account: Annidato<{ email: string }> }[])
    .map((r) => ({ id: r.id, quando: r.creato_il, utente: uno(r.account)?.email ?? 'Sistema', attivita: r.attivita, dettagli: r.dettagli }))
}

export interface Servizio {
  readonly chiave: string
  readonly attivatoIl: string
  readonly scadeIl: string
}

export async function elencaServizi(): Promise<Servizio[]> {
  const { data, error } = await supabase.from('servizio_attivo').select('chiave, attivato_il, scade_il')
  if (error) throw new Error(error.message)
  return (data ?? []).map((r) => ({ chiave: r.chiave, attivatoIl: r.attivato_il, scadeIl: r.scade_il }))
}

export type StatoCredenziale = 'valida' | 'password_scaduta' | 'non_valida'

export interface Credenziale {
  readonly id: number
  readonly portale: string
  readonly username: string
  readonly stato: StatoCredenziale
  readonly impianti: number
  readonly aggiornataIl: string
}

// La password non esce mai dal database: la decifra solo il worker (0025).
export async function elencaCredenziali(): Promise<Credenziale[]> {
  const { data, error } = await supabase
    .from('credenziale_portale')
    .select('id, portale, username, stato, aggiornato_il, credenziale_impianto(count)')
    .order('id')
  if (error) throw new Error(error.message)
  return ((data ?? []) as unknown as { id: number; portale: string; username: string; stato: StatoCredenziale; aggiornato_il: string; credenziale_impianto: { count: number }[] }[])
    .map((r) => ({ id: r.id, portale: r.portale, username: r.username, stato: r.stato, impianti: r.credenziale_impianto[0]?.count ?? 0, aggiornataIl: r.aggiornato_il }))
}
